import { LANGUAGES } from '@/constants/languages';
import type { DocumentDefinition } from '@/types/documentUpload';

import type { LanguageOption } from './modals/document-upload-modal';

export const isFileSizeValid = (fileSize: number, maxFileSizeMb: number): boolean =>
  fileSize <= maxFileSizeMb * 1024 * 1024;

export const resolveLanguageOptions = (
  def: DocumentDefinition,
  t: (key: string) => string,
): LanguageOption[] => {
  const codes =
    def.languageListId === 'ifs-basic-languages' ? LANGUAGES : (def.languages ?? LANGUAGES);
  return codes.map((lang) => ({ value: lang, label: t(`languages.${lang}`) }));
};
